// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "video_draft_clip".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { videoDraftClipProcessingStatusValues, videoDraftClipSourceValues } from '@borradh-workspace/labels';
/** Response atom for the "video_draft_clip" table (1:1 with a DB row, on the wire). */
export const videoDraftClipAtomSchema = z.object({
    id: z.string(),
    videoId: z.string(),
    assetId: z.string().nullable(),
    source: z.enum(videoDraftClipSourceValues),
    beatOrder: z.number(),
    processingStatus: z.enum(videoDraftClipProcessingStatusValues),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=videoDraftClip.js.map